import type { RealityCheckResponse } from '@/types/reality-check';
import { fetchApi } from './fetcher';
import { getConfig } from '@/utils/config/config';
import type { Product } from '@/types/constants';
import { buildApiUrl } from '@/utils/url/build-url';
import { COOKIES, getCookieValue } from '@/utils/cookies';

const UNAUTHORIZED_CODE = 'UAG-005';

const getParams = async (accountId: string) => {
    const config = getConfig();
    const product = process.env.PRODUCT as Product;

    const { RealityCheckClient } = config.apis;
    const { clientId } = config.unifiedModules;
    const host = new URL(`${buildApiUrl(RealityCheckClient)}/${accountId}/reality_check`);
    host.searchParams.set('product', product);

    const headers = {
        ...RealityCheckClient.headers,
        Authorization: `Basic ${Buffer.from(`${clientId}:`).toString('base64')}`,
        'X-Auth-Token': await getCookieValue(COOKIES.AUTH_TOKEN)
    };

    const networkConfig = config.network?.InternalRealityCheckClient;

    return {
        host,
        headers,
        networkConfig
    };
};

export const fetchRealityCheckData = async (accountId: string): Promise<any | null> => {
    const { headers, host, networkConfig } = await getParams(accountId);

    try {
        const res = await fetchApi(host, { method: 'GET', headers }, networkConfig ? { networkConfig } : undefined);

        const json = await res.json();

        if (json.code === UNAUTHORIZED_CODE) {
            console.warn('[fetchRealityCheckData] Unauthorized:', json.details?.message);
            return null;
        }

        return json as RealityCheckResponse;
    } catch (e) {
        console.error(`[fetchRealityCheckData] Error: ${(e as Error).message}`);
        return null;
    }
};
